import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import UserAvatar from "../components/UserAvatar";
import { useTranslation } from "react-i18next";

export default function ChatNav() {
    const { t } = useTranslation();
    const select_chatlist = useSelector((state) => state.chatListReducer);
    const prams = useParams();
    return (
        <>
            <ul className="list-unstyled mb-0 me-3">

                {select_chatlist?.data?.length > 0 && select_chatlist?.data?.map((user, i) => (
                    <li className={`p-2 border-bottom ${prams?.id == user?.to_id ? 'active' : ''}`} key={i}>
                        <Link to={`/home/chat/conversation/${user.to_id}`} className="d-flex justify-content-between">
                            <div className="d-flex flex-row">
                                <div>
                                    <span className="d-flex align-self-center me-2"><UserAvatar src={user.image} name={user.name} size={44} /></span>
                                </div>
                                <div className="pt-1 chat-user-info">
                                    <p className="fw-bold mb-0 chat-list-user-name">{user.name}</p>
                                    <p className="small text-muted mb-0 chat-list-user-massage">{user.message}</p>
                                </div>
                            </div>
                            {user.unread_count > 0 ?
                                <div className="pt-1 chat-user-seenTime">
                                    <p className="small text-muted mb-1">{t("chatNav.just_now")}</p>
                                    <span className="chat-unread-badge float-end">{user.unread_count}</span>
                                </div> : ''
                            }
                        </Link>
                    </li>
                ))}
            </ul>
        </>
    )
}